// extracted by mini-css-extract-plugin
export default {"container":"pagination-message__container___J5Hv4","message":"pagination-message__message___2WunU"};